import { ProductType } from '@main/types/configurations/productType';

import { ResultItemContent, ResultItemContentProps } from '../ResultItemContent';

import styles from './resultItem.module.css';

interface ResultItemProps extends Omit<ResultItemContentProps, 'showChevron'> {
  productType: ProductType;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const ResultItem = ({
  title,
  cost,
  statusText,
  statusColor,
  subTitle,
  insuranceCompany,
  insuranceCompanyDisplayName,
  productType,
  onClick,
}: ResultItemProps) =>
  productType === 'insurance' ? (
    <button
      type="button"
      className={styles.insuranceContainer}
      onClick={onClick}
      data-testid="result-item"
      aria-label={`${title} ${subTitle}`}
    >
      <ResultItemContent
        title={title}
        cost={cost}
        statusText={statusText}
        statusColor={statusColor}
        subTitle={subTitle}
        insuranceCompany={insuranceCompany}
        insuranceCompanyDisplayName={insuranceCompanyDisplayName}
        showChevron
      />
    </button>
  ) : (
    <div className={styles.pensionContainer}>
      <ResultItemContent
        title={title}
        cost={cost}
        statusText={statusText}
        statusColor={statusColor}
        subTitle={subTitle}
        insuranceCompany={insuranceCompany}
        insuranceCompanyDisplayName={insuranceCompanyDisplayName}
      />
    </div>
  );
